"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditBadge = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const CreditBadgeContainer = Theme_1.styled.div `
  width: ${(props) => props.width || '24px'};
  height: ${(props) => props.height || '24px'};
  border-radius: 50%;
  color: ${(props) => props.theme.white};
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: ${(props) => {
    switch (props.badgeContent) {
        case 'A':
        case 'B':
        case 'C':
            return props.theme.colors.green[50];
        case 'F':
        case 'I':
            return props.theme.colors.red[50];
        case 'D':
        case 'N':
        default:
            return props.theme.colors.yellow[50];
    }
}};
`;
const CreditRate = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: 14px;
`;
const CreditBadge = (props) => {
    return (react_1.default.createElement(CreditBadgeContainer, { className: props.className || '', width: props.width, height: props.height, badgeContent: props.badgeContent },
        react_1.default.createElement(CreditRate, null, props.badgeContent)));
};
exports.CreditBadge = CreditBadge;
//# sourceMappingURL=CreditBadge.js.map